import { render, staticRenderFns } from "./HolidayWorkRequestsList.vue?vue&type=template&id=5834fb4c"
import script from "./HolidayWorkRequestsList.vue?vue&type=script&lang=js"
export * from "./HolidayWorkRequestsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports